import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const BackIcon = (props: SvgIconProps) => (
  <SvgIcon width="16" height="16" viewBox="0 0 24 24" fill={"none"} {...props}>
    <path
      d="M14.9997 3C15.5104 2.99996 15.9708 3.30757 16.1662 3.77937C16.3617 4.25116 16.2536 4.79423 15.8925 5.15531L9.04783 11.9996L15.8925 18.844C16.3856 19.337 16.3856 20.1365 15.8925 20.6295C15.3994 21.1226 14.6 21.1226 14.1069 20.6295L6.36983 12.8924C6.13303 12.6557 6 12.3345 6 11.9996C6 11.6648 6.13303 11.3436 6.36983 11.1069L14.1069 3.36974C14.3435 3.13261 14.6648 2.99954 14.9997 3Z"
      fill={props.fill ? props.fill : "white"}
    />
  </SvgIcon>
);

export default BackIcon;
